export const UPDATE_PROJECTS_LIST = "UPDATE_PROJECTS_LIST";
export const UPDATE_PROJECT_DETAIL_MAP = "UPDATE_PROJECT_DETAIL_MAP";
export const UPDATE_TOTAL_PROJECTS = "UPDATE_TOTAL_PROJECTS";
export const UPDATE_SELECTED_PROJECT = "UPDATE_SELECTED_PROJECT";
